import { Box, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';
import { ITheme } from '../../services/types';

interface IProps {
  theme: ITheme;
  fill?: string;
  isEditing?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  wrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 80,
    width: 120,
    backgroundColor: '#10186a',
    marginRight: 4,
    textAlign: 'center',
    wordBreak: 'break-word',
    borderRadius: 4,
    position: 'relative',
    padding: '0 8px',
  },
  title: {
    color: '#fff',
    fontFamily: 'Poppins',
    zIndex: 1,
  },
  graphic: {
    position: 'absolute',
    right: 0,
    bottom: 0,
  },
}));

const PopularThemeItem = (props: IProps): JSX.Element => {
  const { theme, fill = '#0C7FB3', isEditing = false } = props;
  const classes = useStyles();

  return (
    <Box className={classes.wrap} style={isEditing ? { cursor: 'ew-resize' } : undefined}>
      <Typography className={classes.title}>{theme.title}</Typography>
      <svg width="88" height="69" viewBox="0 0 88 69" className={classes.graphic}>
        <g fill="none" fillRule="evenodd">
          <g fill={fill}>
            <path
              d="M88 .025v67.978H0c0-21.297 47.273-23.901 38.896-43.901C33.408 11.502 62.678.579 88.001.025z"
              transform="translate(-1254 -3639) translate(100 68) translate(872 3559) translate(192) translate(90 12.025)"
            />
          </g>
        </g>
      </svg>
    </Box>
  );
};

export default PopularThemeItem;
